module.exports = __webpack_public_path__ + "img/gonetwork2_9.f3ed25b9.png";